const LINKS = [
  { label: 'Impressum', href: '/impressum' },
  { label: 'Datenschutz', href: '/datenschutz' },
  { label: 'AGB', href: '/agb' },
  { label: 'Rechtliche Hinweise', href: '/rechtliche-hinweise' },
];

export function LegalFooter({ className }: { className?: string }) {
  return (
    <footer className={`text-center ${className ?? ''}`}>
      <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] text-text-muted">
        {LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            target="_blank"
            rel="noreferrer"
            className="hover:text-gold-light transition"
          >
            {l.label}
          </a>
        ))}
      </nav>
    </footer>
  );
}
